import { text2number, number2text } from 'core/utils';

export default {
  methods: {
    $text2number(...args) {
      return text2number(...args);
    },

    $number2text(...args) {
      return number2text(...args);
    },

    $isNaN(...args) {
      return isNaN(args);
    }
  }
};
